export default "__VITE_ASSET__CawJvAjs__"